import { ExcludeNil } from '@rbi-ctg/frontend';
import {
  INavigationLinksFragment,
  INavigationSectionFragment,
  INavigationTabsFragment,
  useFeatureNavigationQuery
} from 'generated/sanity-graphql';
import { useFeaturesContext } from 'state/features';

interface IUseFeatureNavigationValue {
  featureNavigationLoading: boolean;
  featureNavigationDesktop: ExcludeNil<INavigationLinksFragment['navigationLinks']>;
  featureNavigationMobile: ExcludeNil<INavigationTabsFragment['navigationTabs']>;
  featureAboutMenuEntriesDesktop: INavigationSectionFragment | null;
  featureAboutMenuEntriesMobile: INavigationSectionFragment | null;
}

export const useFeatureNavigation = (): IUseFeatureNavigationValue => {
  const { featureNavigationId = '', featureIdsLoading } = useFeaturesContext();

  const { data, loading } = useFeatureNavigationQuery({
    variables: { featureNavigationId },
    skip: !featureNavigationId
  });

  const { navigationDesktop, navigationMobile } = data?.FeatureNavigation ?? {};
  const featureNavigationLoading = featureIdsLoading || loading;

  return {
    featureNavigationDesktop: navigationDesktop?.navigationLinks ?? [],
    featureNavigationMobile: navigationMobile?.navigationTabs ?? [],
    featureAboutMenuEntriesDesktop: navigationDesktop?.aboutMenuEntries ?? null,
    featureAboutMenuEntriesMobile: navigationMobile?.aboutMenuEntries ?? null,
    featureNavigationLoading
  };
};
